import { Text } from "@overmap-ai/blocks"
import { type AssetTypeIdentifierValue, type Stored, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectUserById, selectAssetById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"
import { ProjectTimelineCard } from "./ProjectTimelineCard"
import { getTimelineDate } from "./utils"

interface ProjectTimelineAssetIdentifierValueItemProps {
	assetTypeIdentifierValue: Stored<AssetTypeIdentifierValue>
}

export const ProjectTimelineAssetIdentifierValueItem = memo<ProjectTimelineAssetIdentifierValueItemProps>((props) => {
	const { assetTypeIdentifierValue } = props

	const user = useAppSelector(selectUserById(assetTypeIdentifierValue.created_by ?? -1))
	const asset = useAppSelector(selectAssetById(assetTypeIdentifierValue.asset))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ASSET_IDENTIFIER_VALUE}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;updated an identifier value for asset&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/assets/$assetId"
					params={{ assetId: asset.uuid }}
				>
					<AssetTypeIcon className="align-sub" assetTypeId={asset.asset_type} />
					&nbsp;
					<Text className={interactiveTextCva()} accentColor="base">
						<AssetIndexLabel assetId={asset.uuid} highContrast />
						&nbsp;
						<Text>{asset.label || UNLABELLED_ASSET_LABEL}</Text>
					</Text>
				</Link>
				<Text accentColor="base">
					&nbsp;&#8226;&nbsp;{formatCompactDate(getTimelineDate(assetTypeIdentifierValue))}
				</Text>
			</Text>

			<Text size="sm" accentColor="base" className="min-w-0 truncate">
				{assetTypeIdentifierValue.value}
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineAssetIdentifierValueItem.displayName = "ProjectTimelineAssetIdentifierValueItem"
